import dateFormat from "dateformat";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import GameModel from "../model/GameModel";
import AbstractAccuracyScreenMediator from "./AbstractAccuracyScreenMediator";
import TextFitter from "../../../../../shared/lib/html5-software-library/src/ranj/layout/TextFitter";

export default class EndScreenMediator extends AbstractAccuracyScreenMediator {

    /**
     * 
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets);
    }

    initialize() {
        super.initialize();

        const titleTextFitter = new TextFitter(this._target.textPanel.titleTextfield, { fontStep: 1 });
        titleTextFitter.setText(this.getText("end.title"));
        this._target.textPanel.bodyTextfield.text = this.getText("end.body");

        this._button = this.createButton(this._target.textPanel.button, this._handleButtonClick.bind(this), this.getText("end.button"));

        this.anchorObject(this._target.textPanel.titleTextfield, Anchor.T);
        this.anchorObject(this._target.textPanel.bodyTextfield, Anchor.T);
        this.anchorObject(this._target.textPanel.button, Anchor.B);

        this._exposeEndButton();
    }

    _handleButtonClick() {
        this._button.setEnabled(false);
        this.dispatch(GameEvent.EXIT);
    }

    // Used for integration testing by Equalture
    _exposeEndButton() {
        window.actions = window.actions || {};
        window.actions.clickEndButton = () => {
            return new Promise((resolve, reject) => {
                this._handleButtonClick();
                resolve();
            });
        }
    }
};
